module.exports = __webpack_public_path__ + "static/media/Woodgate-Condos-Bylaws.3e9be34d.pdf";